/* import __COLOCATED_TEMPLATE__ from './fin-email-responses-settings.hbs'; */
/* RESPONSIBLE TEAM: team-email */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'embercom/services/intl';
import type EmailResponsesSettings from 'embercom/models/ai-agent/email-responses-settings';
import type AppService from 'embercom/services/app-service';

interface SettingsArgs {
  aiAgentEmailResponsesSettings: EmailResponsesSettings;
  body: any;
}

export default class FinEmailResponsesSettings extends Component<SettingsArgs> {
  @service declare intl: IntlService;
  @service declare intercomEventService: any;
  @service declare appService: AppService;

  constructor(owner: unknown, args: SettingsArgs) {
    super(owner, args);
  }

  get shouldShowQuickRepliesSettings(): boolean {
    return !this.appService.app.isStandaloneApp;
  }

  @action
  beforeSave() {
    // If it's a standalone app, always set quickRepliesEnabled to false
    if (this.appService.app.isStandaloneApp) {
      this.args.aiAgentEmailResponsesSettings.quickRepliesEnabled = false;
    }
  }

  @action
  trackAnalytics() {
    let action = this.args.aiAgentEmailResponsesSettings.showFinFooter ? 'turned_on' : 'turned_off';
    this.intercomEventService.trackAnalyticsEvent({
      action,
      object: 'ai_agent_email_footer_settings',
      context: 'ai_agent_settings',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::FinEmailResponsesSettings': typeof FinEmailResponsesSettings;
    'ai-agent/fin-email-responses-settings': typeof FinEmailResponsesSettings;
  }
}
